<template>
  <keep-alive>
    <b-modal
      :no-close-on-backdrop="true"
      id="update_opening_bal"
      size="md"
      ref="update_opening_bal"
      body-class="bg-white"
      cancel-title="Close"
      cancel-variant="light"
      :ok-title-html="submitted == true ? loaderIcon + 'Update' : 'Update'"
      :title="'Edit'"
      @ok="handleOk"
      :ok-disabled="submitted"
      @shown="value = opening_balance"
    >
      <b-form @submit.stop.prevent="update_opening_bal" id="update_opening_bal">
        <b-form-group>
          <b-row>
            <b-col cols="8">
              <b-form-group
                label="Opening Balance"
                label-for="opening_balance"
                class="mb-3"
                label-class="required"
              >
                <input
                  @blur="roundOff('value', $event)"
                  class="form-control"
                  type="text"
                  name="opening_balance"
                  data-vv-name="Opening Balance"
                  size="sm"
                  v-model.trim="value"
                  v-validate="'required|min_value:0|decimal:2'"
                />
              </b-form-group>
              <span class="text-danger" v-if="errors.has('Opening Balance')">{{
                errors.first("Opening Balance")
              }}</span>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Outstanding Opening Balance"
                label-for="out_opening_balance"
                class="mb-3"
                horizontal
              >
                <p>
                  {{
                    getDetails(
                      $AppDetails.currency_details,
                      currency,
                      "currency_symbol"
                    )
                  }}
                  {{
                    parseFloat(due_amount || 0).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form-group>
      </b-form>
    </b-modal>
  </keep-alive>
</template>
<script>
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";

export default {
  mixins: [notificationMixin],
  props: [
    "opening_balance",
    "due_amount",
    "module",
    "id",
    "currency",
    "unit_currency",
  ],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      value: "",
    };
  },
  created() {
    this.value = this.opening_balance;
  },
  methods: {
    //roundoff paid amount
    roundOff(field) {
      this[field] =
        typeof this[field] != undefined &&
        !isNaN(this[field]) &&
        this[field] != ""
          ? parseFloat(this[field]).toFixed(2)
          : parseFloat(0).toFixed(2);
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();
      this.submitted = true;
      let myForm = document.getElementById("update_opening_bal");
      let formData = {
        id: this.id,
        data: {
          opening_balance: this.value,
          unit_currency: this.unit_currency,
        },
      };
      var url = this.module + "/openingBalanceUpdate";
      store.dispatch(url, formData).then((response) => {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: response.data.type,
          showCloseButton: true,
        });
        this.submitted = false;
        if (response.status == 200) {
          this.$emit("updated");
          this.$refs.update_opening_bal.hide();
        }
      });
    },
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>
